import * as Popover from "@radix-ui/react-popover";
import clsx from "clsx";
import { Bell02 } from "@alchemy/ui/icons/24";

import { analyticsEvent, EventPrefix } from "@util/analytics";
import {
  useHasUnseenNotifs,
  useMarkAllNotifsAsSeen,
} from "../hooks/unseenNotificationHooks";

const NotificationButton = () => {
  const hasUnseenNotifs = useHasUnseenNotifs();
  const markAllNotifsAsSeen = useMarkAllNotifsAsSeen();

  return (
    <Popover.Trigger
      className={clsx(
        "relative flex h-10 w-10 items-center justify-center rounded-full transition",
        "border-[1.5px] border-transparent bg-grayscale-100 text-grayscale-900",
        "outline-none focus-visible:shadow-focus",
        "hover:border-primary-500 hover:text-primary-500",
        "aria-expanded:bg-grayscale-900 aria-expanded:text-grayscale-50",
      )}
      aria-label="Notifications"
      onClick={() => {
        markAllNotifsAsSeen();

        analyticsEvent(
          `${EventPrefix.Alerts}: Opened alerts notification panel`,
        );
      }}
    >
      <Bell02 />

      {hasUnseenNotifs && (
        <div className="absolute right-0 top-0 h-3 w-3 rounded-full bg-critical-600" />
      )}
    </Popover.Trigger>
  );
};

export default NotificationButton;
